import React from 'react'
import reactStamp from 'react-stamp'
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import FlatButton from 'material-ui/FlatButton';
import Links from '../../router/links'
import './header.css'

export default reactStamp(React).compose({

    init(){
        this.handleLogout = this.handleLogout.bind(this);
        this.handleLoginOnClick = this.handleLoginOnClick.bind(this);
        this.handleSignUpOnClick = this.handleSignUpOnClick.bind(this);
        this.getLoginButton = this.getLoginButton.bind(this);
        this.getRegisterButton = this.getRegisterButton.bind(this);
        this.handleLogoOnClick = this.handleLogoOnClick.bind(this);
    },

    render() {
        return (
            <div className="portal-header">
                <FlatButton
                    className="header-logo"
                    label="Anypoint Clinic"
                    onTouchTap={this.handleLogoOnClick}
                />
                {this.props.name != undefined ?
                    <div className="header-menu">
                        <h3 className="logged-name">{this.props.name}</h3>
                        <IconMenu
                            iconButtonElement={<IconButton className="menu-icon-button"><MoreVertIcon color="white"/></IconButton>}
                            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                            targetOrigin={{horizontal: 'right', vertical: 'top'}}
                        >
                            <MenuItem
                                primaryText="Log out"
                                onTouchTap={this.handleLogout}
                            />
                        </IconMenu>

                    </div> : null }

                {this.props.operations == "login" ?
                    <div className="header-menu">
                        {this.getLoginButton()}
                    </div> : null}

                {this.props.operations == "register" ?
                    <div className="header-menu">
                        {this.getRegisterButton()}
                    </div> : null}

                {this.props.operations.includes("register") && this.props.operations.includes("login") ?
                    <div className="header-menu">
                        {this.getLoginButton()}
                        {this.getRegisterButton()}
                    </div> : null
                }


            </div>
        )
    },

    getLoginButton(){
        return <FlatButton
            className="header-button"
            label="Login"
            onTouchTap={this.handleLoginOnClick}
        />
    },

    getRegisterButton(){
        return <FlatButton
            className="header-button"
            label="Join us today"
            onTouchTap={this.handleSignUpOnClick}
        />
    },

    handleLogout(){
        sessionStorage.setItem('id', "");
        sessionStorage.setItem('name', "");
        Links.toLogin();
    },

    handleLoginOnClick(){
        Links.toLogin();
    },

    handleSignUpOnClick(){
        Links.toSignUp();
    },
    
    handleLogoOnClick(){
        Links.toWelcome()
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Header/index.js
 **/